export default {
  name: 'backUp',
  icon: {
    tag: 'svg',
    attrs: { viewBox: '0 0 12 12', width: '12', height: '12', fill: 'none' },
    children: [
      {
        tag: 'path',
        attrs: {
          d: 'M11.2502 6.0002H0.750244M0.750244 6.0002L4.31256 9.75021M0.750244 6.0002L4.31256 2.25018',
          stroke: '#1E5FC7',
          strokeWidth: '1.5',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
        },
      },
    ],
  },
}
